<script>
import Velocity from 'velocity-animate'
import shadowBox from '../shadow/index.vue';
const directionOpt = {
    right: 'right',
    left: 'left',
    top: 'top',
    bottom: 'bottom'
};
const directionStyle = {
    top: {
        top: 0,
        left: 0,
        right: 0
    },
    bottom: {
        bottom: 0,
        left: 0,
        right: 0
    },
    right: {
        right: 0,
        top: 0,
        bottom: 0
    },
    left: {
        left: 0,
        top: 0,
        bottom: 0
    }
};
const getStyle = (direction, openExpandSize, closeExpandSize) => {
    let position = directionStyle[direction];
    switch (direction) {
        case directionOpt.right:
            return {
                position,
                transform: {
                    open: {
                        translateX: `${100 - openExpandSize}%`
                    },
                    close: {
                        translateX: `${100 - closeExpandSize}%`
                    }
                }
            };
        case directionOpt.left:
            return {
                position,
                transform: {
                    open: {
                        translateX: `${openExpandSize - 100}%`
                    },
                    close: {
                        translateX: `${closeExpandSize + -100}%`
                    }
                }
            };
        case directionOpt.top:
            return {
                position,
                transform: {
                    open: {
                        translateX: `${openExpandSize - 100}%`
                    },
                    close: {
                        translateX: `${closeExpandSize + -100}%`
                    }
                }
            };
        case directionOpt.bottom:
            return {
                position,
                transform: {
                    open: {
                        translateX: `${100 - openExpandSize}%`
                    },
                    close: {
                        translateX: `${100 - closeExpandSize}%`
                    }
                }
            };
    }
};
export default {
    props: {
        // 打开方向
        direction: {
            type: String,
            default: 'right'
        },
        // 打开后展示总大小的百分比
        openExpandSize: {
            type: [String, Number],
            default: '100',
            validator(value) {
                return +value >= 0 && +value <= 100;
            }
        },
        // 关闭后展示总大小的百分比，默认0
        closeExpandSize: {
            type: [String, Number],
            default: '0',
            validator(value) {
                return +value >= 0 && +value <= 100;
            }
        },
        width: {
            type: [String, Number],
            default: '70%'
        },
        height: {
            type: [String, Number],
            default: '100%'
        },
        zIndex: {
            type: [String, Number],
            default: '100'
        },
        status: {
            type: Boolean,
            default: false
        },
        clickShadowAutoClose: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        style() {
            return getStyle(this.direction, this.openExpandSize, this.closeExpandSize);
        }
    },
    methods: {
        clickShadow() {
            if (this.clickShadowAutoClose) {
                this.$emit('update:status', false);
            }
        },
        beforeEnter(el) {
            Velocity(el, {
                ...this.style.transform.close
            }, {
                duration: 0
            });
        },
        enter(el, done) {
            Velocity(el, {
                ...this.style.transform.open
            }, {
                duration: 225,
                easing: [0, 0, 0.2, 1],
                complete: done
            });
        },
        leave(el, done) {
            Velocity(el, {
                ...this.style.transform.close
            }, {
                duration: 225,
                easing: [0, 0, 0.2, 1],
                complete: done
            })
        }
    },
    components: {
        shadowBox
    }
}
</script>

<template>
    <div>
        <shadow-box 
            :status="status"
            @click="clickShadow"
        ></shadow-box>
        <transition 
            name="drawer-slide-fade"
            :css="false"
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
        >
            <div
                v-if="status"
                class="drawer-container"
                :style="{
                    width: width,
                    height: height,
                    zIndex: zIndex,
                    ...style.position
                }"
            >
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<style lang="stylus" scoped>
.drawer-container
    position fixed
</style>